import { defineMessages } from 'react-intl';

export default {
  pages: {
    signup: {
      registration: {
        steps: {
          createAccount: {
            ...defineMessages({
              headerTitle: {
                id: 'pages.signup.registration.steps.createAccount.headerTitle',
                defaultMessage: 'Sign up for free',
              },
              genericError: {
                id: 'pages.signup.registration.steps.createAccount.genericError',
                defaultMessage: 'Something went wrong. Please try again.',
              },
              login: {
                id: 'pages.signup.registration.steps.createAccount.login',
                defaultMessage: 'Already have an account? <a>Login here</a>',
              },
              button: {
                id: 'pages.signup.registration.steps.createAccount.button',
                defaultMessage: 'Create an Account',
              },
            }),
            changeEmail: {
              ...defineMessages({
                button: {
                  id: 'pages.signup.registration.steps.createAccount.changeEmail.button',
                  defaultMessage: 'Save',
                },
              }),
            },
          },
        },
      },
    },
  },
};
